module.exports = __webpack_public_path__ + "static/img/2_4_1.c59e1142.jpg";